export const EXCLUSIVE_FILTER_ID = '__exclusive_reports__';
export const EXCLUSIVE_FILTER_NAME = 'Exclusive';
export const UNCATEGORIZED_FILTER_ID = '__uncategorized_reports__';
export const UNCATEGORIZED_FILTER_NAME = 'Uncategorized';